<template>
    <div v-if="buildingInfo">
        <div class="row" style="width: 100%">
            <div class="col-1">
                <div class="building-title-container">
                    <div class="building-title">{{ "건축물 개요" }}</div>
                    <!-- <span class="building-icon">
                        <i class="fa fa-building"></i>
                    </span> -->
                    <img src="@assets/default/icon/analysis_icon.png" width="55" />
                </div>
            </div>
            <div class="col-8">
                <table
                    class="table table-bordered text-center align-middle mb-0"
                    style="table-layout: fixed; width: 100%; font-size: 0.8rem"
                >
                    <colgroup>
                        <col style="width: 13%" />
                        <col style="width: 17%" />
                        <col style="width: 13%" />
                        <col style="width: 22%" />
                        <col style="width: 13%" />
                        <col style="width: 22%" />
                    </colgroup>
                    <tbody>
                        <!-- 1행: 건물 식별·규모 (3) -->
                        <tr>
                            <th class="text-white" scope="row">{{ "건축물 명" }}</th>
                            <td>{{ buildingInfo.buildingName ?? "-" }}</td>
                            <th class="text-white" scope="row">{{ "용도" }}</th>
                            <td>{{ buildingInfo.usage ?? "-" }}</td>
                            <th class="text-white" scope="row">{{ "건물 정보" }}</th>
                            <td>
                                {{
                                    `지상 ${buildingInfo.grdFloor ?? "-"}층 / 지하 ${buildingInfo.urgFloor ?? "-"}층 / 연면적 ${buildingInfo.totalArea} ㎡`
                                }}
                            </td>
                        </tr>
                        <!-- 2행: 에너지·녹색 인증 (3) -->
                        <tr>
                            <th class="text-white" scope="row">{{ "건축물에너지효율 등급" }}</th>
                            <td>{{ buildingInfo.EECRating ?? "-" }} ({{ buildingInfo.EECDate ?? "-" }})</td>
                            <th class="text-white" scope="row">{{ "제로에너지건축물 등급" }}</th>
                            <td>{{ buildingInfo.ZEBRating ?? "-" }} ({{ buildingInfo.ZEBDate ?? "-" }})</td>
                            <th class="text-white" scope="row">{{ "녹색건축인증" }}</th>
                            <td>
                                <template v-if="buildingInfo.GseedRating">
                                    <div>
                                        {{ buildingInfo.GseedRating }}
                                        <span>
                                            ({{ buildingInfo.GseedDate ?? "-" }} ~
                                            {{ buildingInfo.GseedValidUntil ?? "-" }})
                                        </span>
                                    </div>
                                </template>
                                <template v-else>-</template>
                            </td>
                        </tr>
                        <!-- 3행: 시점·위치 (2) -->
                        <tr>
                            <th class="text-white" scope="row">{{ "준공일" }}</th>
                            <td>{{ buildingInfo.operStDate ?? "-" }}</td>
                            <th class="text-white" scope="row">{{ "주소" }}</th>
                            <td colspan="3">{{ buildingInfo.siteAddr ?? "-" }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-3">
                <!-- {{ "search button" }} -->
                <div style="display: flex; width: 100%; height: 50%; justify-content: space-between">
                    <div style="height: 100%; width: 50%; display: flex; margin-right: 5px">
                        <div style="width: 15%; height: 2.125rem">
                            <button class="date-icon-prev" v-b-tooltip :title="'이전 연 조회'" @click="prevYear">
                                <i class="fas fa-angle-left" aria-hidden="true"></i>
                            </button>
                        </div>
                        <div style="width: 70%; height: 100%">
                            <DatePicker
                                class="bldInfoCalendar"
                                v-model="yearDate"
                                :type="'year'"
                                :format="'YYYY년'"
                                :valueType="'YYYY'"
                                :placeholder="'연 선택'"
                                lang="ko"
                                @change="selectYearDate"
                            />
                        </div>
                        <div style="width: 15%; height: 2.125rem">
                            <button class="date-icon-next" v-b-tooltip :title="'다음 연 조회'" @click="nextYear">
                                <i class="fas fa-angle-right" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <div style="height: 100%; width: 50%; display: flex; margin-left: 5px">
                        <div style="width: 15%; height: 2.125rem">
                            <button class="date-icon-prev" v-b-tooltip :title="'이전 월 조회'" @click="prevMonth">
                                <i class="fas fa-angle-left" aria-hidden="true"></i>
                            </button>
                        </div>
                        <div style="width: 70%; height: 100%" class="bldInfoMonth">
                            <DatePicker
                                class="bldInfoCalendar"
                                v-model="monthDate"
                                :type="'month'"
                                :format="'MM월'"
                                :valueType="'MM'"
                                :placeholder="'월 선택'"
                                lang="ko"
                                :append-to-body="false"
                                @change="runAnalysis(yearDate, monthDate)"
                            />
                        </div>
                        <div style="width: 15%; height: 2.125rem">
                            <button class="date-icon-next" v-b-tooltip :title="'다음 월 조회'" @click="nextMonth">
                                <i class="fas fa-angle-right" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div style="display: flex; width: 100%; height: 50%; gap: 5px">
                    <div style="width: 50%">
                        <button @click="openBldDataModal" type="button" class="btn btn-primary" style="width: 100%">
                            {{ "데이터" }}
                        </button>
                    </div>
                    <div style="width: 50%">
                        <button @click="exportPDF" type="button" class="btn btn-secondary" style="width: 100%">
                            {{ "보고서" }}
                        </button>
                    </div>
                    <div style="width: 50%">
                        <button
                            @click="openTabSettingsModal"
                            type="button"
                            class="btn btn-secondary"
                            style="width: 100%"
                        >
                            {{ "탭 설정" }}
                        </button>
                    </div>
                    <div style="width: 50%">
                        <button
                            @click="openPointConfigModal"
                            type="button"
                            class="btn btn-secondary"
                            style="width: 100%"
                        >
                            {{ "관제점 설정" }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 탭 설정 모달 -->
        <b-modal ref="tabSettingsRef" @hidden="hideTabSettingsModal" id="tabSettings" size="md" title="탭 설정">
            <div class="tab-settings-container">
                <div class="tab-settings-description">
                    <i class="fas fa-info-circle"></i>
                    <span>표시할 탭을 선택하세요. (최소 1개 이상 선택 필요)</span>
                </div>
                <div class="tab-settings-list">
                    <div
                        v-for="tab in tabSettingsList"
                        :key="tab.key"
                        class="tab-setting-item"
                        :class="{ active: tab.visible }"
                    >
                        <label :for="'tab-' + tab.key" class="tab-setting-label">
                            <div class="tab-setting-content">
                                <div class="tab-icon-wrapper">
                                    <app-icon :icon="tab.icon" />
                                </div>
                                <span class="tab-label-text">{{ tab.label }}</span>
                            </div>
                            <b-form-checkbox
                                v-model="tab.visible"
                                :id="'tab-' + tab.key"
                                switch
                                @change="checkMinTabCount"
                                class="tab-setting-switch"
                            ></b-form-checkbox>
                        </label>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <div class="tab-settings-footer">
                    <button type="button" class="btn btn-secondary" @click="hideTabSettingsModal">취소</button>
                    <button type="button" class="btn btn-primary" @click="saveTabSettings">저장</button>
                </div>
            </template>
        </b-modal>

        <b-modal ref="bldDataRef" @hidden="hideBldDataModal" id="bldData" hide-footer size="lg" title="데이터">
            <div class="tab-header-wrapper">
                <b-tabs v-model="activeTab">
                    <b-tab v-if="timeDsvn === 'MONTH'">
                        <template #title>
                            <span class="tab-title"><i class="material-icons">cloud</i> 에너지원별 CO₂ 배출량</span>
                        </template>

                        <bld-data-table
                            :data="bldData.carbon"
                            :exportExcel="exportExcel && activeTab === 0"
                            @update:exportExcel="updateExcel"
                        />
                    </b-tab>

                    <b-tab v-else-if="timeDsvn === 'YEAR'">
                        <template #title>
                            <span class="tab-title"
                                ><i class="material-icons">battery_charging_full</i> 에너지 사용량</span
                            >
                        </template>

                        <bld-data-table
                            :data="bldData.grade"
                            :exportExcel="exportExcel && activeTab === 0"
                            @update:exportExcel="updateExcel"
                        />
                    </b-tab>

                    <b-tab>
                        <template #title>
                            <span class="tab-title"><i class="fas fa-leaf"></i> 신재생 에너지 발전량</span>
                        </template>
                        <bld-data-table
                            :data="bldData.consume"
                            :exportExcel="exportExcel && activeTab === 1"
                            @update:exportExcel="updateExcel"
                        />
                    </b-tab>
                    <b-tab>
                        <template #title>
                            <span class="tab-title"><i class="fas fa-thermometer-half"></i> 운영 환경 데이터</span>
                        </template>
                        <bld-data-table
                            :data="bldData.env"
                            :exportExcel="exportExcel && activeTab === 2"
                            @update:exportExcel="updateExcel"
                        />
                    </b-tab>
                </b-tabs>
                <button class="tab-download-btn" @click="updateExcel(true)">엑셀 다운로드</button>
            </div>
        </b-modal>

        <EngEffPointConfigModal ref="pointConfigModalRef" @saved="onPointConfigSaved" />
    </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import BldDataTable from "../tables/BldDataTable.vue";
import EngEffPointConfigModal from "../modal/EngEffPointConfigModal.vue";

export default {
    props: ["buildingInfo", "activeTab", "data"],
    components: {
        DatePicker,
        BldDataTable,
        EngEffPointConfigModal,
    },
    data() {
        const prevMonth = moment().subtract(1, "months");
        return {
            exportExcel: false,
            yearDate: prevMonth.format("YYYY"),
            monthDate: prevMonth.format("MM"),

            /* 탭 설정 목록 */
            tabSettingsList: [
                {
                    key: "carbon",
                    label: "에너지 및 탄소 분석",
                    icon: "fa fa-cloud",
                    visible: true,
                },
                {
                    key: "consumption",
                    label: "소비 및 생산 분석",
                    icon: "fas fa-leaf",
                    visible: true,
                },
                {
                    key: "environment",
                    label: "운영 환경 분석",
                    icon: "fas fa-thermometer-half",
                    visible: true,
                },
                {
                    key: "cost",
                    label: "원단위 및 비용 분석",
                    icon: "fa fa-calculator",
                    visible: true,
                },
            ],

            bldData: {
                carbon: {
                    // regDt: this.data.carbonData.values.co2Trend.regDt,

                    // unit: null,
                    thData: [],
                    data: null,
                },
                grade: {
                    thData: [],
                    data: null,
                },
                consume: {
                    // regDt: this.data.consumpData.values.trend.regDt,
                    // unit: null,
                    thData: [],
                    data: null,
                },
                env: {
                    // regDt: this.data.envData.values.consTempTrend.regDt,
                    // unit: this.data.envData.values.consTempTrend.unitCode.totalUsage,
                    thData: [],
                    data: null,
                },
            },
        };
    },
    computed: {
        timeDsvn() {
            if (this.data.carbonData) {
                return this.data.carbonData.headers[0].timeDsvn;
            } else {
                return "-";
            }
        },
    },
    watch: {
        data(newVal) {
            if (newVal) {
                if (this.timeDsvn === "MONTH") {
                    this.formatMonthDataModal();
                } else if (this.timeDsvn === "YEAR") {
                    // 곧
                    this.formatYearDataModal();
                }
            }
        },
    },
    mounted() {
        this.runAnalysis(this.yearDate, this.monthDate);
        // console.log(moment().subtract(1, "years").format("YYYY"));
    },
    created() {},
    methods: {
        formatYearDataModal() {
            if (!this.data) return;
            // 에너지 사용량 추이 및 자립률 트렌드 데이터
            this.handleGradeData();
            // 소비 및 생산 분석 관련 데이터
            this.handleConsumeData();
            // // 운영 환경 분석 관련 데이터
            this.handleEnvData();
        },
        handleGradeData() {
            const chartDataEff = this.data.carbonData.values.energyGradeTrend.efficiency.chartData;
            const chartDataZeb = this.data.carbonData.values.energyGradeTrend.zeb.chartData;

            // console.log("this.data.carbonData.values.energyGradeTrend ", this.data.carbonData.values.energyGradeTrend);
            const unitEff = this.data.carbonData.values.energyGradeTrend.efficiency.unitInfo.unit;
            const unitZeb = "%";

            const regDt = this.data.carbonData.values.energyGradeTrend.efficiency.labels;

            if (chartDataEff && chartDataZeb && regDt) {
                //테이블 헤더 생성
                const thList = [
                    { label: `사용량 (${unitEff})`, key: "orgUnitValue" },
                    { label: `자립률 (${unitZeb})`, key: "selfRate" },
                ];
                this.bldData.grade.thData = thList;

                // 테이블 데이터 생성
                this.bldData.grade.data = regDt.map((date, index) => {
                    const row = { date };

                    row["orgUnitValue"] = chartDataEff["orgUnitValue"]?.[index]
                        ? `${chartDataEff["orgUnitValue"]?.[index]} (${chartDataEff["efficiencyGrade"]?.[index]}등급)`
                        : "-";
                    row["selfRate"] = chartDataZeb["selfRate"]?.[index]
                        ? `${chartDataZeb["selfRate"]?.[index]} (${chartDataZeb["zebGrade"]?.[index]})`
                        : "-";

                    return row;
                });
            } else {
                console.warn("grade 데이터가 존재하지 않음");
            }
        },
        prevMonth() {
            const current = moment(`${this.yearDate}-${this.monthDate}`, "YYYY-MM");
            const prev = current.subtract(1, "months");
            this.yearDate = prev.format("YYYY");
            this.monthDate = prev.format("MM");
            this.runAnalysis(this.yearDate, this.monthDate);
        },

        nextMonth() {
            const current = moment(`${this.yearDate}-${this.monthDate}`, "YYYY-MM");
            const next = current.add(1, "months");
            this.yearDate = next.format("YYYY");
            this.monthDate = next.format("MM");
            this.runAnalysis(this.yearDate, this.monthDate);
        },
        prevYear() {
            const prevYear = moment(this.yearDate, "YYYY").subtract(1, "years");
            this.yearDate = prevYear.format("YYYY");
            this.monthDate = null;
            this.runAnalysis(this.yearDate, this.monthDate);
        },
        nextYear() {
            const nextYear = moment(this.yearDate, "YYYY").add(1, "years");
            this.yearDate = nextYear.format("YYYY");
            this.monthDate = null;
            this.runAnalysis(this.yearDate, this.monthDate);
        },
        exportPDF() {
            this.$emit("exportPDF");
        },
        updateExcel(val) {
            this.exportExcel = val;
        },
        formatMonthDataModal() {
            if (!this.data) return;
            // 에너지 및 탄소 분석 관련 데이터
            this.handleCarbonData();
            // 소비 및 생산 분석 관련 데이터
            this.handleConsumeData();
            // // 운영 환경 분석 관련 데이터
            this.handleEnvData();
        },
        handleCarbonData() {
            if (!this.data.carbonData) return;

            const chartData = this.data.carbonData.values.co2Trend.chartData;
            const regDt = this.data.carbonData.values.co2Trend.regDt;
            const unit = this.data.carbonData.values.co2Trend.unit ?? "";

            if (chartData && regDt) {
                // 초기값
                const thList = [{ label: "외기온도 (℃)", key: "outerTemp" }];

                let totalColumn = { label: `합계 (${unit})`, key: "total" };

                Object.keys(chartData).forEach((key) => {
                    if (key === "outerTemp" || key === "total") return;

                    const exists = thList.some((th) => th.key === key);
                    if (!exists) {
                        thList.push({
                            label: `${key} (${unit})`,
                            key,
                        });
                    }
                });

                // 마지막에 합계 넣기
                thList.push(totalColumn);

                // thData 최종 저장
                this.bldData.carbon.thData = thList;

                // 테이블 행 생성
                this.bldData.carbon.data = regDt.map((date, index) => {
                    const row = { date };
                    thList.forEach((th) => {
                        row[th.key] = chartData[th.key]?.[index] ?? "-";
                    });
                    return row;
                });
            } else {
                console.warn("co2Trend 데이터가 존재하지 않음");
                this.bldData.carbon.data = [];
            }
        },
        handleConsumeData() {
            if (!this.data.consumpData) return;

            const chartData = this.data.consumpData.values.trend.chartData;
            const regDt = this.data.consumpData.values.trend.regDt;
            const unitObj = this.data.consumpData.values.trend.unit;

            if (chartData && regDt) {
                const thList = [{ label: "외기온도 (℃)", key: "outerTemp" }];

                let totalColumn = null;

                Object.keys(chartData).forEach((key) => {
                    if (key === "outerTemp" || key === "total") return;

                    const label = `${key} (${unitObj[key] ?? ""})`;

                    thList.push({ label, key });
                });

                if (totalColumn) thList.push(totalColumn);

                this.bldData.consume.thData = thList;

                this.bldData.consume.data = regDt.map((date, index) => {
                    const row = { date };
                    thList.forEach((th) => {
                        row[th.key] = chartData[th.key]?.[index] ?? "-";
                    });
                    return row;
                });
            } else {
                console.warn("consumpData 데이터가 존재하지 않음");
                this.bldData.consume.data = [];
            }
        },
        handleEnvData() {
            if (!this.data.envData) return;

            const chartData = this.data.envData.values.consTempTrend.trend.chartData;
            const regDt = this.data.envData.values.consTempTrend.trend.regDt;
            const unit = this.data.envData.values.consTempTrend.trend.unitCode.totalUsage;

            if (chartData && regDt) {
                const thList = [
                    { label: "외기온도 (℃)", key: "outerTemp" },
                    { label: "실내온도 (℃)", key: "indoorTemp" },
                ];

                let totalColumn = { label: `에너지 소비량 합계 (${unit})`, key: "totalUsage" };

                this.bldData.env.thData = [...thList, totalColumn];

                this.bldData.env.data = regDt.map((date, index) => {
                    const row = { date };
                    this.bldData.env.thData.forEach((th) => {
                        row[th.key] = chartData[th.key]?.[index] ?? "-";
                    });
                    return row;
                });
            } else {
                console.warn("envData 데이터가 존재하지 않음");
                this.bldData.env.data = [];
            }
        },
        openBldDataModal() {
            this.$refs.bldDataRef.show();
        },
        hideBldDataModal() {
            this.$refs.bldDataRef.hide();
        },
        /* 탭 설정 모달 열기 */
        openTabSettingsModal() {
            // 현재 탭 설정 로드
            this.loadCurrentTabSettings();
            this.$refs.tabSettingsRef.show();
        },
        /* 탭 설정 모달 닫기 */
        hideTabSettingsModal() {
            this.$refs.tabSettingsRef.hide();
        },
        /* 관제점 설정 모달 열기 */
        openPointConfigModal() {
            this.$refs.pointConfigModalRef.show();
        },
        /* 관제점 설정 저장 후 현재 조회 기간으로 리포트 재조회 */
        onPointConfigSaved() {
            this.runAnalysis(this.yearDate, this.monthDate);
        },
        /* 현재 탭 설정 로드 */
        loadCurrentTabSettings() {
            try {
                const savedSettings = localStorage.getItem("buildingEnergyEfficiencyTabSettings");
                if (savedSettings) {
                    const settings = JSON.parse(savedSettings);
                    this.tabSettingsList.forEach((tab) => {
                        if (settings.hasOwnProperty(tab.key)) {
                            tab.visible = settings[tab.key];
                        }
                    });
                } else {
                    // 기본값: 모두 true
                    this.tabSettingsList.forEach((tab) => {
                        tab.visible = true;
                    });
                }
            } catch (err) {
                console.error("탭 설정 로드 실패:", err);
            }
        },
        /* 최소 탭 개수 체크 */
        checkMinTabCount() {
            const visibleCount = this.tabSettingsList.filter((tab) => tab.visible).length;
            if (visibleCount === 0) {
                this.$nextTick(() => {
                    this.$alertWarning("최소 1개 이상의 탭은 표시되어야 합니다.");
                    // 마지막 체크 해제 시도 방지
                    const lastVisibleTab = this.tabSettingsList.find((tab) => tab.visible);
                    if (!lastVisibleTab) {
                        // 모두 체크 해제된 경우 첫 번째 탭 자동 체크
                        this.tabSettingsList[0].visible = true;
                    }
                });
            }
        },
        /* 탭 설정 저장 */
        async saveTabSettings() {
            // 최소 1개 이상 체크 확인
            const visibleCount = this.tabSettingsList.filter((tab) => tab.visible).length;
            if (visibleCount === 0) {
                this.$alertWarning("최소 1개 이상의 탭은 표시되어야 합니다.");
                return;
            }

            // 확인 메시지
            const result = await this.alertConfirmWarning("탭 설정을 변경하시겠습니까?");
            if (!result.value) {
                return;
            }

            // 부모 컴포넌트에 설정 전달
            const settings = {};
            this.tabSettingsList.forEach((tab) => {
                settings[tab.key] = tab.visible;
            });
            this.$emit("updateTabSettings", settings);
            this.hideTabSettingsModal();

            // 저장 완료 메시지
            this.$nextTick(() => {
                this.alertNoti("탭 설정을 변경하였습니다.");
            });
        },
        selectYearDate(newVal) {
            // console.log("selectYearDate before", newVal);
            this.monthDate = null;
            // console.log("selectYearDate", this.yearDate);
            this.runAnalysis(newVal);
        },
        runAnalysis(year, month) {
            // console.log("runAnalysis", year, month);
            this.$emit("search", year, month);
        },
    },
};
</script>

<style scoped>
.row {
    margin: 0px;
}
.building-title-container {
    width: 100%;
    height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.building-title {
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 5px;
}
.building-icon {
    font-size: 2rem;
}
.table td,
.table th {
    padding: 4px 6px;
    height: auto;
    min-height: 28px;
    vertical-align: middle;
}

.table th {
    background-color: #003366;
}
.date-icon-prev {
    color: #555;
    background-color: #fff;
    border: solid #bbb 1px;
    /* border-radius: 5px; */
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.2rem;
    transition: background-color 0.5s;
    width: 100%;
    height: 100%;
}
.date-icon-next {
    color: #555;
    background-color: #fff;
    border: solid #bbb 1px;
    /* border-radius: 5px; */
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.2rem;
    transition: background-color 0.5s;
    width: 100%;
    height: 100%;
}

.date-icon-prev:hover {
    background-color: #c7c7c7;
}
.date-icon-next:hover {
    background-color: #c7c7c7;
}

.date-icon.active {
    color: #fff;
    background-color: #555;
}
.tab-title i {
    font-size: 16px;
    vertical-align: middle;
    margin-right: 4px;
}

.tab-download-btn {
    position: absolute;
    top: 8px;
    right: 5px;
    padding: 6px 12px;
    background-color: #007bff;
    color: #fff;
    border: none;
    font-size: 13px;
    border-radius: 4px;
    cursor: pointer;
    z-index: 10;
}
.tab-download-btn:hover {
    background-color: #0056b3;
}
.tab-header-wrapper {
    position: relative;
    max-height: 85vh;
    overflow-y: auto;
}
.tab-download-btn:active,
.tab-download-btn:focus {
    border: none;
    outline: none;
}
.tab-settings-container {
    padding: 15px 0;
}

.tab-settings-description {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background-color: #e3f2fd;
    border-left: 4px solid #2196f3;
    border-radius: 4px;
    margin-bottom: 20px;
    font-size: 0.875rem;
    color: #1565c0;
}

.tab-settings-description i {
    font-size: 1rem;
    color: #2196f3;
}

.tab-settings-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.tab-setting-item {
    border: 2px solid #e9ecef;
    border-radius: 8px;
    background-color: #ffffff;
    transition: all 0.3s ease;
    overflow: hidden;
}

.tab-setting-item:hover {
    border-color: #007bff;
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.15);
    transform: translateY(-2px);
}

.tab-setting-item.active {
    border-color: #28a745;
    background-color: #f8fff9;
    box-shadow: 0 4px 8px rgba(40, 167, 69, 0.15);
}

.tab-setting-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px;
    margin: 0;
    cursor: pointer;
    width: 100%;
}

.tab-setting-content {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
}

.tab-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background-color: #f8f9fa;
    transition: all 0.3s ease;
}

.tab-setting-item.active .tab-icon-wrapper {
    background-color: #d4edda;
}

.tab-icon-wrapper i {
    font-size: 1.125rem;
    color: #6c757d;
    transition: color 0.3s ease;
}

.tab-setting-item.active .tab-icon-wrapper i {
    color: #28a745;
}

.tab-label-text {
    font-size: 0.95rem;
    font-weight: 500;
    color: #495057;
    transition: color 0.3s ease;
}

.tab-setting-item.active .tab-label-text {
    color: #155724;
    font-weight: 600;
}

.tab-setting-switch {
    margin-left: 12px;
}

.tab-settings-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    width: 100%;
}

.tab-settings-footer .btn {
    min-width: 80px;
    padding: 8px 20px;
    font-weight: 500;
}
</style>
